import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import ContentSection from '@/components/ContentSection';

const About = () => {
    return (
        <Layout>
            <div className="bg-gray-50 min-h-screen">
                <PageHeader title="About Us" />

                <ContentSection centered>
                    <p className="text-xl text-gray-600 leading-relaxed mb-8">
                        As passionate photography enthusiasts, we love capturing the unique bond
                        between pets and their people. This gallery is a showcase of our work,
                        celebrating the special moments shared with furry companions.
                    </p>
                    <p className="text-lg text-gray-500 leading-relaxed">
                        Every photograph tells a story of love, joy, and the irreplaceable
                        connection between humans and their beloved pets.
                    </p>
                </ContentSection>
            </div>
        </Layout>
    );
};

export default About;
